export const apiEndpoints = {
    loginUrl: `admin/auth/login`,
    signUrl: `admin/auth/signup`,
    forgetUrl: 'admin/auth/forgot_password',
    otpVerifyUrl: "admin/auth/verify_otp",
    resendOtpUrl: "admin/auth/resend_otp",
    changePasswordUrl: "admin/auth/change/password",
    resetPasswordUrl: "admin/auth/reset_password",
    profileUrl: "admin/auth/details",
    commonContentUrl: "admin/common/common_content",
    commonContentUpdateUrl: "admin/common/common_content",
    faqGetUrl: "admin/common/questions",
    faqCommonUrl: "admin/common/question",
    userGetUrl: "admin/user/list",
    userDetailsUrl: "admin/user/details",
    userStatusUrl: "admin/user/status",
    userDashboardUrl: "admin/user/dashboard",
    userDashboardReportUrl: "admin/user/dashboard_report",
    faqUpdateUrl: "admin/common/updatequestion",
    getProfileData: "admin/auth/details",
    updatePassword: "admin/auth/change_password",
    updateAdmin: "admin/auth/profile",
    getDashboardUrl: "admin/auth/dashboard_count",
    uploadQuotesFileUrl: "admin/quote/add",
    promptDataUrl: 'admin/ai_prompts/getAll',
    updatePromtDataUrl: `admin/ai_prompts/update`,
    getPromptDetailsDataUrl: `admin/ai_prompts/details`,
    subscriptionChartUrl: "admin/user/subscription_chart",

    getCategoryUrl: `admin/category/getAll`,
    addCategoryUrl: `admin/category/create`,
    updateCategoryUrl: `admin/category/update`,
    deleteCategoryUrl: `admin/category/delete`,

    // BREED MAP ENDPOINTS
    getBreedsUrl: `admin/breed_map/getAll`,
    addBreedUrl: `admin/breed_map/create`,
    updateBreedUrl: `admin/breed_map/update`,
    deleteBreedUrl: `admin/breed_map/delete`,

    // HAIR CUT STYLE (Style Details) ENDPOINTS
    getStylesUrl: `admin/style_details/getAll`,
    addStyleUrl: `admin/style_details/create`,
    updateStyleUrl: `admin/style_details/update`,
    deleteStyleUrl: `admin/style_details/delete`,

    // BREED GROOMING STYLE ENDPOINTS
    getBreedListForGroomingUrl: `admin/breed_grooming_style/breed-list`,
    getBreedGroomingStylesUrl: `admin/breed_grooming_style/list`,
    addBreedGroomingStyleUrl: `admin/breed_grooming_style/create`,
    updateBreedGroomingStyleUrl: `admin/breed_grooming_style/update`,
    deleteBreedGroomingStyleUrl: `admin/breed_grooming_style/delete`,
    deleteBreedGroomingStyleStyleUrl: `admin/breed_grooming_style/style/delete`,
    deleteBreedGroomingStyleImageUrl: `admin/breed_grooming_style/style/image/delete`,

    quotesGetUrl: "admin/quote/list",
    quotesAddUrl: "admin/quote/add",
    deleteQuetesUrl: "admin/quote/delete",
    updateQuetesUrl: "admin/quote/update",

    addInsultUrl: "admin/insult/add",
    insultGetUrl: "admin/insult/list",
    insultAddUrl: "admin/insult/add",
    deleteInsultUrl: "admin/insult/delete",
    updateInsultUrl: "admin/insult/update",
    uploadInsultFileUrl: "admin/insult/add",
    updateLanguageUrl: "admin/auth/update_language",

    // BACKGROUND IMAGE ENDPOINTS
    getBgImagesUrl: "admin/background_image/list",
    addBgImageUrl: "admin/background_image/create",
    updateBgImageUrl: "admin/background_image/update",
    changeBgImageStatusUrl: "admin/background_image/change_status",
    deleteBgImageUrl: "admin/background_image/delete",
    getBgImageDetailsUrl: "admin/background_image/details",

    // STICKER ENDPOINTS
    getStickersUrl: "admin/sticker/list",
    addStickerUrl: "admin/sticker/create",
    updateStickerUrl: "admin/sticker/update",
    changeStickerStatusUrl: "admin/sticker/change_status",
    deleteStickerUrl: "admin/sticker/delete",
    getStickerDetailsUrl: "admin/sticker/details",

    //
    getBgCategoryUrl: "admin/background_category/list",
    addBgCategoryUrl: "admin/background_category/create",
    updateBgCategoryUrl: "admin/background_category/update",
    getBgCategoryDetailsUrl: "admin/background_category/details",
    changeBgCategoryStatusUrl: "admin/background_category/change_status",
    deleteBgCategoryUrl: "admin/background_category/delete",
    addBackgroundSubCategorySortingUrl: "admin/background_category/subcategory_shorting",

    //report

    reportListUrl: "admin/report/list",
    reportDetailsUrl: "admin/report/details",
    reportDeleteUrl: "admin/report/delete",
    reportAcceptUrl: "admin/report/accept",
    reportRejectUrl: "admin/report/reject",

    // user report
    userReportListUrl: "admin/user_report/list",
    userReportDetailsUrl: "admin/user_report/details",
    userReportActionUrl: "admin/user_report/action",
    userReportDeleteUrl: "admin/user_report/delete",

    // Contact Us Endpoints
    contactUsListUrl: "admin/contactus/list",
    contactUsDeleteUrl: "admin/contactus/delete",
    contactUsReplyUrl: "admin/contactus/reply",

    // STICKER CATEGORY ENDPOINTS
    getStickerCategoryUrl: "admin/sticker_category/list",
    addStickerCategoryUrl: "admin/sticker_category/create",
    updateStickerCategoryUrl: "admin/sticker_category/update",
    changeStickerCategoryStatusUrl: "admin/sticker_category/change_status",
    deleteStickerCategoryUrl: "admin/sticker_category/delete",
    addStickerSubCategorySortingUrl: "admin/sticker_category/subcategory_shorting",
    getStickerPromptsUrl: "admin/sticker_prompt/list",
    addStickerPromptUrl: "admin/sticker_prompt/create",
    updateStickerPromptUrl: "admin/sticker_prompt/update",
    changeStickerPromptStatusUrl: "admin/sticker_prompt/change_status",
    deleteStickerPromptUrl: "admin/sticker_prompt/delete",
    getStickerPromptDetailsUrl: "admin/sticker_prompt/details",

    //bg category prompt
    getBgPromptCategoryListUrl: "admin/background_category_prompt/list",
    addBgPromptCategoryUrl: "admin/background_category_prompt/create",
    updateBgPromptCategoryUrl: "admin/background_category_prompt/update",
    changeBgPromptCategoryStatusUrl: "admin/background_category_prompt/change_status",
    deleteBgPromptCategoryUrl: "admin/background_category_prompt/delete",
    bgPromptCategorySortingUrl: "admin/background_category_prompt/subcategory_shorting",
    getBgPromptListUrl: "admin/background_prompt/list",
    addBgPromptUrl: "admin/background_prompt/create",
    updateBgPromptUrl: "admin/background_prompt/update",
    changeBgPromptStatusUrl: "admin/background_prompt/change_status",
    deleteBgPromptUrl: "admin/background_prompt/delete",
    getBgPromptDetailsUrl: "admin/background_prompt/details",

    // HAIRCUT PROMPT (Grooming) ENDPOINTS
    getHaircutPromptListUrl: "admin/haircut_grooming/getAll",
    getHaircutPromptDetailsUrl: "admin/haircut_grooming/details",
    updateHaircutPromptUrl: "admin/haircut_grooming/update",
    deleteHaircutPromptUrl: "admin/haircut_grooming/delete",

    // ORDERS ENDPOINTS
    getOrdersUrl: "admin/orders/getAll",
    getOrderDetailsUrl: "admin/orders/details",
    updateOrderUrl: "admin/orders/update",
    reviewStatsUrl: "admin/user/review_stats",
}